import {PlanningParameter} from './planning-parameter';

export class PlanningParameterCollection {
    private totalItems: number = 0;
    private planningParameters: PlanningParameter[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setPlanningParameters(planningParameters: PlanningParameter[]) {
        this.planningParameters = planningParameters;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getPlanningParameters(): PlanningParameter[] {
        return this.planningParameters;
    }
}
